import { defaultOptions } from "../global/slick-options";
import { getAll } from "../utilities/querySelector";

const camperGallerySlider = getAll('[data-slider="camper-gallery-slider"]');

let options = {
    ...defaultOptions,
};

if (camperGallerySlider.length) {
    camperGallerySlider.forEach((slider) => {
        options = {
            ...defaultOptions,
            slidesToShow: 1,
            arrows: true,
            infinite: true,
            centerMode: true,
            centerPadding: "0",
        };

        jQuery(slider).slick({
            ...options,
        });
    });
}
